import FormActionParamTypes from '../constants/form_action_param_types';
import { FormAPI } from 'lecom-api';

export const parseActionParams = (action, params) => {
	return params.reduce((parsedParams, param) => {
		const parsedParam = parseActionParam(action, param);
		return Object.assign(parsedParams, parsedParam);
	}, {});
};

const parseActionParam = (action, param) => {
	switch(param.type) {
		case FormActionParamTypes.VALUE:
			return parseValueActionParam(param);
		case FormActionParamTypes.FIELD:
			return parseFieldActionParam(action, param);
		default:
			return {};
	}
};

const parseValueActionParam = (param) => {
	return { [param.name]: param.value };
};

const parseFieldActionParam = (action, param) => {
	const fieldValue = getFieldValue(action, param.formField);
	return { [param.name]: fieldValue };
};

const getFieldValue = (action, field) => {
	const formAPI = FormAPI.form(action.formId);

	return (field.gridFormParent)
		? formAPI.fields(field.gridFormParent).fields(field.id).value()
		: formAPI.fields(field.id).value();
};

export default {
	parseActionParams
};
